export default "__VITE_ASSET__DiiJptaL__"